import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgOtherGlyphSecondary(props) {
  return jsx("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    d: "M24.32 14.64c1.83 0 3.32-1.49 3.32-3.32 0-1.83-1.49-3.32-3.32-3.32C22.49 8 21 9.49 21 11.32c0 1.83 1.49 3.32 3.32 3.32Zm0-5.14c1 0 1.82.82 1.82 1.82s-.82 1.82-1.82 1.82-1.82-.82-1.82-1.82.82-1.82 1.82-1.82ZM24.32 20.68C22.49 20.68 21 22.17 21 24c0 1.83 1.49 3.32 3.32 3.32 1.83 0 3.32-1.49 3.32-3.32 0-1.83-1.49-3.32-3.32-3.32Zm0 5.14c-1 0-1.82-.82-1.82-1.82s.82-1.82 1.82-1.82 1.82.82 1.82 1.82-.82 1.82-1.82 1.82ZM24.32 33.36c-1.83 0-3.32 1.49-3.32 3.32 0 1.83 1.49 3.32 3.32 3.32 1.83 0 3.32-1.49 3.32-3.32 0-1.83-1.49-3.32-3.32-3.32Zm0 5.14c-1 0-1.82-.82-1.82-1.82s.82-1.82 1.82-1.82 1.82.82 1.82 1.82-.82 1.82-1.82 1.82Z",
    fill: "currentColor"
  }));
}

export { SvgOtherGlyphSecondary as default };
